module.exports = __webpack_public_path__ + "img/24adad1ff191e5a7a2380278384e3d62.png";